import authentication from "@irati/auth";
import OnboardingService from "../services/onboarding";
export default (function (step, includeTenantEligibility) {
    if (includeTenantEligibility === void 0) { includeTenantEligibility = false; }
    var tourEligibility = {
        tenant: true,
        user: false
    };
    var promises = [];
    if (includeTenantEligibility) {
        var loadTenantOnboarding = OnboardingService.getTenantOnboarding()
            .then(function (tenantOnboarding) {
            if (!tenantOnboarding || !(tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.enabled)) {
                tourEligibility.tenant = false;
            }
        });
        promises.push(loadTenantOnboarding);
    }
    if (!authentication.isUserGhost()) {
        var loadUserOnboarding = OnboardingService.get(authentication.user().uuid)
            .then(function (_a) {
            var completedSteps = _a.completedSteps;
            if (!completedSteps.includes(step)) {
                tourEligibility.user = true;
            }
        });
        promises.push(loadUserOnboarding);
    }
    return Promise.all(promises).then(function () { return tourEligibility.tenant && tourEligibility.user; });
});
